import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/es5/util/colors";
import es from "vuetify/src/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#519DE1",
        secondary: "#26A1FF",
        accent: colors.orange.accent2,
        error: colors.deepOrange.base,
        warning: colors.amber.base,
        info: colors.indigo.base,
        success: colors.teal.base,
      },
      dark: {
        background: "#091717", // el fondo principal oscuro (Off-Black)
        surface: "#121F1F", // para tarjetas/modales, un tono algo más claro que el fondo
        primary: "#20808D", // el color “teal” de Perplexity como primario
        secondary: "#1B6C73", // una versión más oscura del teal para secundarios
        accent: "#4ABBB0", // un acento más brillante cercano al teal
        error: colors.deepOrange.accent4, // un color cálido para errores
        warning: colors.amber.accent3, // amarillo para advertencias
        info: "#64CFE8", // azul-turquesa claro para información
        success: colors.green.accent3, // verde brillante para éxito
        onBackground: "#FBFAF4", // color claro para texto sobre fondo oscuro
        onSurface: "#E0E0E0", // texto en superficie
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
